import LabServiceModel from "@/models/LabServiceModel";
import SampleModel from "./SampleModel";
import SampleStatusModel from "./SampleStatusModel";

export default class SampleStatusLogModel extends LabServiceModel {

  modelName() {
    return 'sample-status-log';
  }

  defaults() {
    return {
      id: null,
      sample_id: null,
      sample: null,
      sample_status_id: null,
      sample_status: null,
      start_date: null,
      end_date: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
    }
  }

  // Attribute mutations.
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      sample_id: (val) => (this.nullStringMutator(val)),
      sample_status_id: (val) => (this.nullStringMutator(val)),
      start_date: String,
      end_date: String,
      created_at: String,
      updated_at: String,
      deleted_at: String
    }
  }

  // Attribute validation
  validation() {
    return {}
  }

  getSample() {
    return this.getRelatedModel(SampleModel, 'sample');
  }

  getSampleStatus() {
    return this.getRelatedModel(SampleStatusModel, 'sample_status');
  }

}
